import { Component, OnInit, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { TppClaimantsModel } from '../../../models/tppclaimantsmodel';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tpp-complete',
  templateUrl: './tpp-complete.html',
  styleUrls: ['./tpp-complete.css'],
  imports: [DatePipe], // Add this using the DatePipe Directive in the template
})

  @Injectable({
    providedIn: 'root' // Add this line for LocalStorageService
  })

export class TppComplete implements OnInit {
  claimant: TppClaimantsModel;

  constructor(
    private storage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.claimant = this.storage.retrieve('claimant');
  }
}
